import React from 'react';
import CopyButton from './CopyButton';

export interface CredentialsViewProps {
  title?: string;
  description?: string;
  fields: Array<{ label: string; value: string; mono?: boolean }>;
  notice?: string;
  delivered?: { email?: boolean; sms?: boolean };
}

const CredentialsView: React.FC<CredentialsViewProps> = ({
  title,
  description,
  fields,
  notice,
  delivered,
}) => {
  const allDetails = fields.map((f) => `${f.label}: ${f.value}`).join('\n');

  return (
    <div className="space-y-4">
      {title && <h3 className="text-base font-semibold text-white">{title}</h3>}
      {description && <p className="text-sm text-slate-400">{description}</p>}

      <div className="space-y-2 rounded-xl border border-slate-800 bg-slate-950/50 p-4">
        {fields.map((f) => (
          <div key={f.label} className="flex items-center gap-3">
            <span className="w-24 flex-shrink-0 text-xs uppercase tracking-wider text-slate-500">
              {f.label}
            </span>
            <span
              className={`flex-1 break-all text-sm text-white ${
                f.mono ? 'font-mono' : ''
              }`}
            >
              {f.value}
            </span>
            <CopyButton value={f.value} small />
          </div>
        ))}
      </div>

      {(delivered?.email || delivered?.sms) && (
        <div className="flex flex-wrap gap-2 text-xs">
          {delivered.email && (
            <span className="rounded-full bg-emerald-500/10 px-3 py-1 text-emerald-300 border border-emerald-500/30">
              Sent to email
            </span>
          )}
          {delivered.sms && (
            <span className="rounded-full bg-emerald-500/10 px-3 py-1 text-emerald-300 border border-emerald-500/30">
              Sent via SMS
            </span>
          )}
        </div>
      )}

      {notice && (
        <p className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-3 text-xs text-amber-300">
          {notice}
        </p>
      )}

      <div className="flex justify-end pt-2">
        <CopyButton value={allDetails} label="Copy all details" />
      </div>
    </div>
  );
};

export default CredentialsView;
